import { ArrowLeft, ArrowRight, Clock3, ListChecks, Timer } from "lucide-react";
import { Button } from "../ui/Button";
import { Card } from "../ui/Card";

const infoCards = [
  { icon: Clock3, text: "Διάρκεια: περίπου 8–12 λεπτά" },
  { icon: ListChecks, text: "Ερωτήσεις: 30" },
  { icon: Timer, text: "Χρονισμός: συνολικός και ανά ερώτηση" }
];

export function TestIntroScreen({ onStart, loading }: { onStart: () => void; loading: boolean }) {
  return (
    <div className="mx-auto grid min-h-[calc(100svh-4rem)] w-full max-w-4xl content-center px-4 py-8 sm:px-6">
      <Card>
        <h1 className="text-3xl font-bold text-white sm:text-4xl">Πριν ξεκινήσεις</h1>
        <p className="mt-4 max-w-2xl leading-7 text-slate-300">
          Θα απαντήσεις σε 30 ερωτήσεις λογικής, μοτίβων, αριθμητικών ακολουθιών και χωρικής αντίληψης. Το test καταγράφει τον συνολικό χρόνο και τον χρόνο απόκρισης ανά ερώτηση.
        </p>
        <div className="mt-6 grid gap-3 sm:grid-cols-3">
          {infoCards.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.text} className="flex items-center gap-3 rounded-lg border border-white/10 bg-white/[0.045] p-4">
                <Icon className="shrink-0 text-cyan-200" size={22} />
                <p className="text-sm font-semibold text-slate-100">{item.text}</p>
              </div>
            );
          })}
        </div>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Button type="button" onClick={onStart} disabled={loading} className="w-full sm:w-auto">
            {loading ? "Ξεκινά..." : "Έναρξη IQ Test"} <ArrowRight className="ml-2" size={18} />
          </Button>
          <Button href="/" variant="secondary" className="w-full sm:w-auto">
            <ArrowLeft className="mr-2" size={18} /> Επιστροφή στην αρχική
          </Button>
        </div>
      </Card>
    </div>
  );
}
